import moment from 'moment'
import { useMemo } from 'react'

import { ImageComponent } from '@apps-common/components/common'
import { myMonitoringEventIconBuilder } from '@apps-common/config/my-monitoring-event-icon'
import { useSignalStrengthIcon } from '@apps-common/hooks/useSignalStrengthIcon'
import { IMMSiteEvent } from '@apps-common/types/my-monitoring'
import classNames from 'classnames'
import { SlUser } from 'react-icons/sl'

export const SiteEventItemSkeleton = () => (
  <div className='bg-skeleton border border-skeleton-border animate-pulse min-h-[80px] rounded-2xl' />
)

interface IProps {
  containerClasses?: string
  data: IMMSiteEvent
}
export const SiteEventItem: React.FC<IProps> = ({ containerClasses, data }) => {
  const signal = useSignalStrengthIcon(parseInt(data?.signalStrength, 10))

  const Icon = useMemo(() => myMonitoringEventIconBuilder(data?.eventType, data?.icon), [data])
  const eventType = data.eventType

  return (
    <div
      className={classNames(containerClasses, 'relative w-full bg-surface-2 text-text border border-border rounded-2xl overflow-hidden')}
    >
      <div className='absolute z-1 left-0 top-0 h-full w-[6px]'>
        <div
          className={classNames(
            'h-full w-full rounded-full',
            eventType.toLowerCase() === 'r' && 'bg-error',
            eventType.toLowerCase() === 'e' && 'bg-success'
          )}
        />
      </div>
      <div className='flex items-center justify-between ml-3 px-2 py-1 pb-0'>
        <div className='jost-light text-[0.75em]'>{moment(data.timeStamp).format('Do MMM YY, hh:mm:ss')}</div>
        <div className='flex items-center justify-end rounded-full px-[5px] py-[1px] text-[1.4rem]'>{signal.Icon}</div>
      </div>
      <div className='relative z-2 ml-1 p-2 flex items-center justify-start'>
        <div className='grow flex flex-col items-between justify-center gap-4'>
          <div className='flex items-center justify-between'>
            <div className='flex flex-col items-start justify-center gap-[5px] px-2'>
              <div className='jost-light text-[0.8em] rounded flex items-center justify-start gap-[10px]'>{data.description}</div>
              <div className='gap-1 jost text-[0.8rem] text-text/60'>
                {data.altDescription && <div>{data.altDescription}</div>}
                {!data.altDescription && (
                  <div className='flex items-center justify-start pr-[6px]'>
                    Zone:{data?.zone} Partition:{data.partition}
                  </div>
                )}
              </div>
            </div>
            <div className=''>
              <div className='flex items-center justify-start gap-1'>
                {data?.isUserEvent && (
                  <>
                    {data?.profileImage && (
                      <ImageComponent
                        src={data?.profileImage}
                        alt='User profile image'
                        imageClasses='w-[24px] h-[24px] rounded-full border border-border'
                      />
                    )}
                    {!data?.profileImage && (
                      <div className='bg-text/5 rounded-full border border-text/40 overflow-hidden p-[2px]'>
                        <SlUser className='text-text/40 relative bottom-[-3px]' />
                      </div>
                    )}
                  </>
                )}
                <div className='px-1 py-[5px] flex items-center justify-start'>{Icon}</div>
              </div>
              {/* {data.altDescription && (
                <div className='flex items-center justify-start gap-1 jost-light text-[0.8rem] bg-surface-2 text-text/70 px-2 rounded-full'>
                  {data.altDescription}
                </div>
              )}
              {!data.altDescription && (
                <div className='flex items-center justify-start gap-1 jost-light text-[0.75rem] bg-surface-2 text-text/70 px-2 rounded-full'>
                  Z:{data?.zone} P:{data.partition}
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
